<template>
  <form class="language-select">
    <select required @change="changeLang">
      <option
        v-for="(item, i) in languagesList"
        :key="i"
        :value="item.key"
        :selected="isChecked(item.key)"
      >
        {{ item.value }}
      </option>
    </select>
  </form>
</template>

<script>
import Api from '@libraries/api/'
import RequestLocale from '@requests/locale'
import { mapGetters } from 'vuex'
import { languages, languageLabels } from '@constants'

export default {
  name: 'LanguageSelect',
  computed: {
    ...mapGetters('login', ['apiKey']),
    languagesList() {
      return languageLabels.enums
    },
  },
  methods: {
    isChecked(key) {
      return this.$route.params.lang === languages.get(key).value
    },
    changeLang(e) {
      const params = { ...this.$route.params }
      const query = { ...this.$route.query}
      params.lang = languages.get(e.target.value).value
      Api.call(new RequestLocale(params.lang, this.apiKey))
        .then(() => {
          this.$router.push({ params: params, query: query })
          window.scrollTo(0, 0)
        })
        .catch(({error}) => {
          this.$router.push({ params: params, query: query })
          window.scrollTo(0, 0)
          throw error
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.language-select {
  select {
    appearance: none;
    outline: none;
    background: transparent;
    width: 100%;
    height: 52px;
    border: solid 2px #69512e;
    border-radius: 0;
    background-color: #e0dab1;
    padding: 0 20px;
    background-image: url(#{$img-path}language-select/bg_select.png);
    background-position: 100% 50%;
    background-repeat: no-repeat;
    background-size: auto 100%;
    &:focus {
      outline: none;
    }
    &::-ms-expand {
      display: none;
    }
  }
}
</style>
